import { getCookie } from '@/modern/utils/cookies'
import { targetApiConfig } from './targetApiConfig'

export function getVisitorData({ adobeOrg }) {
  return new Promise((resolve, reject) => {
    let visitor = {}
    let sdid = null
    let mcmid = null

    function handleVisitorData(ids) {
      const { MCMID = '' } = ids
      const { _supplementalDataIDCurrent: supplementalDataID = '' } = visitor
      sdid = supplementalDataID || visitor.getSupplementalDataID()
      mcmid = MCMID
      resolve({
        sdid: supplementalDataID || visitor.getSupplementalDataID(),
        mcmid: MCMID,
      })
    }

    if (window.Visitor) {
      visitor = window.Visitor.getInstance(adobeOrg)
      if (process.env.NODE_ENV !== 'production') {
        window.visitor = visitor
      }
      visitor.getVisitorValues(handleVisitorData)
      setTimeout(() => {
        if (!sdid || !mcmid) reject(new Error('Visitor is not defined'))
      }, 1000)
    } else {
      reject(new Error('Visitor is not defined'))
    }
  })
}

export function getMCMIDFromCookie() {
  const adobeCookie = getCookie(
    `${targetApiConfig.cookiePrefix}${targetApiConfig.adobeOrg}`
  )
  if (!adobeCookie) return null

  const MCMIDKey = '|MCMID|'
  const decodedCookie = decodeURI(adobeCookie)
  if (!decodedCookie.includes(MCMIDKey)) return null

  const MCMIDIndex = decodedCookie.indexOf(MCMIDKey)
  const MCMID = decodedCookie
    .substring(MCMIDIndex + MCMIDKey.length)
    .split('|')[0]

  return MCMID || null
}

export function getFBCLIDFromUrl(searchString) {
  if (!searchString) return ''
  const urlParams = new URLSearchParams(searchString)
  const fbclid = urlParams.get('fbclid') || ''
  return fbclid
}
